import { pathToRegexp } from 'path-to-regexp';

import { Filters } from '../interfaces/filters';
import { privateRoutes } from '../routes/appRouteList';
import { getEnv } from './environmentUtils';

export const serializeFilterQueryParams = (filters: Filters): URLSearchParams => {
    const urlParams = new URLSearchParams();

    urlParams.append('earliest_delivery_departure_timestamp', filters.earliest_delivery_departure_timestamp);
    urlParams.append('latest_delivery_departure_timestamp', filters.latest_delivery_departure_timestamp);

    if (filters.commodity_codes.length > 0) {
        urlParams.append('commodity_codes', filters.commodity_codes.toString());
    }

    if (filters.pickup_party_ids.length > 0) {
        urlParams.append('pickup_party_ids', filters.pickup_party_ids.toString());
    }

    if (filters.delivery_party_ids.length > 0) {
        urlParams.append('delivery_party_ids', filters.delivery_party_ids.toString());
    }

    if (filters.freight_order_specified_eqpt_codes.length > 0) {
        urlParams.append('freight_order_specified_eqpt_codes', filters.freight_order_specified_eqpt_codes.toString());
    }

    if (filters.carrier_business_unit_codes.length > 0) {
        urlParams.append('carrier_business_unit_codes', filters.carrier_business_unit_codes.toString());
    }

    if (filters.minimum_revenue_usd_amount !== null) {
        urlParams.append('minimum_revenue_usd_amount', filters.minimum_revenue_usd_amount.toString());
    }

    if (filters.maximum_revenue_usd_amount !== null) {
        urlParams.append('maximum_revenue_usd_amount', filters.maximum_revenue_usd_amount.toString());
    }

    return urlParams;
};

export const buildLaneLink = (origin: string, dest: string, filters: Filters): string => {
    const urlParams = serializeFilterQueryParams(filters);
    urlParams.append('origin', origin);
    urlParams.append('dest', dest);

    return `${privateRoutes.lanes}?${urlParams}`;
};

export const buildAreaLink = (areaId: string, filters: Filters): string => {
    const urlParams = serializeFilterQueryParams(filters);
    return `/areas/${areaId}?${urlParams}`;
};

export const buildAreaBalanceLink = (areaId: string, filters: Filters): string => {
    const urlParams = serializeFilterQueryParams(filters);
    return `/area-balance/${areaId}?${urlParams}`;
};

export const buildShipperLink = (shipperId: string, filters: Filters): string => {
    const urlParams = serializeFilterQueryParams({
        ...filters,
        pickup_party_ids: [],
    });
    return `/shippers/${encodeURIComponent(shipperId)}?${urlParams}`;
};

export const buildShipperHealthLink = (shipperId: string): string => {
    return `/shipper-health/${encodeURIComponent(shipperId)}`;
};

export const getEngageLaneLink = (): string => {
    switch (getEnv()) {
        case 'local':
        case 'development':
            return 'https://prizmway-procurement.dev.trimble-transportation.com';
        case 'staging':
            return 'https://prizmway-procurement.stg.trimble-transportation.com';
        case 'prod':
        default:
            return 'https://engagelane.trimble-transportation.com';
    }
};

export const getMarketInsightsLink = (): string => {
    switch (getEnv()) {
        case 'local':
        case 'development':
            return 'https://transportation-insights.dev.trimble-transportation.com';
        case 'staging':
            return 'https://transportation-insights.stg.trimble-transportation.com';
        case 'prod':
        default:
            return 'https://transportation-insights.trimble-transportation.com';
    }
};

export const routeComparator = (routeList: string[], routeToCompare: string): boolean => {
    return routeList.some((route) => {
        const routeRegex = pathToRegexp(route);
        return routeRegex.regexp.test(routeToCompare);
    });
};
